export function setRooms(data) {
  return { type: "SET_ROOMS", data };
}

export function setRoomDetail(data) {
  return { type: "SET_ROOM_DETAIL", data };
}
